/* eslint-disable react/jsx-pascal-case */
import * as React from 'react'
import { ArticleKeys, AssortedFields, ProjectInvoice/*, TypeAheadKeys, TypeAheadStateKeys */} from '../../pages/KickbackProjectReportPage';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger } from 'react-bootstrap';
import DatePicker_react from '../DatePicker/DatePicker_react';
import { _helpers } from '../../lib/ProjectReportValidation';
import { Placement } from 'react-bootstrap/esm/types';
type InputFieldKeys = Pick<ProjectInvoice, "totalExclMoms" | "invoiceNumber" | "comment" | 'articleNumber' | 'articlePricePerUnit' | 'articleQuantity' | 'articleQuantityType' | 'articleText' | 'rowSumExclMoms'>
type DateFields = Pick<ProjectInvoice,"billingDate" | "projectEndDate">
type OnChangeToRun = Pick<InputFieldOnChange,"onChangeForArticle" | "onChangeForOriginal" | "onChangeForInvTagComRef">
type InputFieldOnChange = {
  onChangeForOriginal?:(uniqueRowId:Readonly<number>,e:Readonly<any>,key:Readonly<keyof InputFieldKeys> ) => Promise<void> ;
  onChangeForArticle?:(item:Readonly<ProjectInvoice>,e:Readonly<any>,key:Readonly<keyof ArticleKeys>) => Promise<void>;
  onChangeForInvTagComRef?:(val:any,row:Readonly<ProjectInvoice>,key:keyof AssortedFields) => void;
}

interface ProjectFieldProps{
    divStyle:Pick<React.HTMLAttributes<HTMLElement>,"className" | "style">
    item:Readonly<ProjectInvoice>;
    inputField:Readonly<keyof InputFieldKeys> | Readonly<keyof ArticleKeys> | Readonly<keyof AssortedFields>;
    overlay:Readonly<boolean>;
    value:Readonly<string|number| readonly string[] | undefined>;
    placeHolder:Readonly<string>;
    placement:Readonly<Placement | undefined>;
    onChange?:{key:Readonly<keyof OnChangeToRun>,change:InputFieldOnChange};
    disabled?:boolean;
    showValidationInfo?:(props:any,key:Readonly<keyof InputFieldKeys>) => JSX.Element;
    
}
export const ProjectInputField = ({divStyle,item,inputField,overlay,value,placeHolder,placement,onChange,disabled,showValidationInfo}:ProjectFieldProps) =>{  
 const [cache,setCache] = React.useState<any>(value)
 const timerHandler = React.useRef<NodeJS.Timeout>()
 React.useEffect(() => {
  setCache(value)
},[item.id])
const internalOnChange = (e:React.ChangeEvent<HTMLInputElement>) => {

  switch(onChange?.key){
    case 'onChangeForArticle' : onChange?.change['onChangeForArticle']?.(item,e.target.value as any,inputField as keyof ArticleKeys) 
    break
    case 'onChangeForInvTagComRef' : onChange?.change['onChangeForInvTagComRef']?.(e.target.value,item,inputField as keyof AssortedFields)
    break
    case 'onChangeForOriginal' : onChange.change['onChangeForOriginal']?.(item.uniqueRowId,e.target.value as any,inputField as keyof InputFieldKeys)
    break
  }
}
  return(
        <>
              
        <div {...divStyle}>
          {inputField !== 'comment' ?
          <>
          <input
          placeholder={placeHolder/*i18n.t('kickbackProject.fieldInvoiceNumberInput') ?? ''*/}
          //style={{width:'125px'}}
          type="text"
          autoComplete="off"
          spellCheck="false"
          
          disabled={disabled}
          onChange={(e) =>
            {
              clearTimeout(timerHandler.current)
              const pendingValue = e
              setCache(pendingValue.target.value)
              timerHandler.current = setTimeout(() => {
                internalOnChange(pendingValue)
              },500)
            } 
          }
          value={disabled == true  ? value: cache} 
         
        />
        {overlay &&
           <FontAwesomeIcon
            className="exclamationIconStyle"
              icon={faExclamation}
            /> 
        }
        </>
        :
         (<input 
            className="commentInputField"
            type="text"
            onChange={(e) =>{
              clearTimeout(timerHandler.current)
              const pendingValue = e
              setCache(pendingValue.target.value)
              timerHandler.current = setTimeout(() => {
                internalOnChange(pendingValue)
              },500)
            }
            }
            autoComplete="off"
            spellCheck="false"
            disabled={disabled}
            defaultValue={cache}
            />
          )
          }
          
          { overlay && (
            <>
            <OverlayTrigger
              placement={placement}
              delay={{ show: 250, hide: 400 }}
              overlay={typeof showValidationInfo !== 'undefined' ? (props) => showValidationInfo(props, inputField as keyof InputFieldKeys) : (props) => <></>}
            >
              <FontAwesomeIcon
            className="exclamationIconStyle"
              icon={faExclamation}
            />
            </OverlayTrigger>
          
           </> 
          )}
        </div>
         
       
        
        </>
    )
}
interface ProjectDateFieldProps{
  divStyle:Pick<React.HTMLAttributes<HTMLElement>,"className" | "style">;
  dateField:keyof DateFields;
  item:ProjectInvoice | any;
  period:string;
  overlay:boolean;
  minMax:boolean;
  handleDatechange:(event:Date | null ,item:ProjectInvoice/*uniqueRowId:number*/) => void;
  showValidationInfo:(props:any,key:keyof DateFields) => JSX.Element;

}
export const ProjectDateField = ({divStyle,dateField,item,period,overlay,minMax,handleDatechange,showValidationInfo}:ProjectDateFieldProps) => {
 
 return <div {...divStyle}>
              <DatePicker_react
            locale={"sv-SE"}
            dateFormat={"yyyy-MM-dd"}
            selected={ item[dateField] ? new Date(item[dateField]) : null}
            minDate={minMax ? new Date(_helpers.getMinOrMaxDateRange("min",period as string)) : null}
            maxDate={minMax ? new Date(_helpers.getMinOrMaxDateRange("max",period as string)) : null}
            onChange={(e) => {handleDatechange(e, item)}}
            placeholderText="YYYY-MM-DD"
          />
          {overlay && (
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={(props) => showValidationInfo(props, dateField)}
            >
              <FontAwesomeIcon
              className="exclamationIconStyle"
                icon={faExclamation}
              />
            </OverlayTrigger>
          )}
        </div>
}